const routes = {
    home: '/',
    dashboard: '/dashboard',
    leaderboard: '/dashboard/leaderboard',
    scoreHistory: '/dashboard/score-history',
    // me: '/dashboard/me',
    authentication: '/authentication',
    login: '/authentication/login',
    // register: '/authentication/register',
};

export default routes;
